import styled from "styled-components";
import { Link } from "react-router-dom";

export const FooterContainer = styled.div`
  background: var(--bg-base);
  padding: 4rem 0 2.5rem 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-top: 1px solid var(--border-subtle);
`;



export const FooterLinksContainer = styled.div`
  width: 100%;
  max-width: 1000px;
  display: flex;
  justify-content: center;

  @media screen and (max-width: 750px) {
    padding-top: 32px;
  }
`;

export const FooterLinksWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: center;
`;

export const FooterLinkItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 16px;
  text-align: left;
  width: 160px;
  box-sizing: border-box;
  color: #000;
`;

export const FooterLinkTitle = styled.h3`
  margin-bottom: 16px;
`;

export const FooterLink = styled(Link)`
  color: #666666;
  text-decoration: none;
  margin-bottom: 0.5rem;
  transition: all 0.3s ease;

  &:hover {
    color: #fcd13f;
  }
`;

export const SocialMedia = styled.section`
  max-width: 1000px;
  width: 100%;
`;

export const SocialMediaWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90%;
  max-width: 1000px;
  margin: 40px auto 0 auto;

  @media screen and (max-width: 750px) {
    flex-direction: column;
  }
`;

export const SocialLogo = styled(Link)`
  color: #402204;
  justify-self: start;
  cursor: pointer;
  text-decoration: none;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-weight: 700;
  margin-top: 0.4rem;
  transition: all 0.3s ease;

  &:hover {
    color: #fcd13f;
  }
`;

export const SocialIcon = styled.img.attrs(({ lang }) => ({
  src: lang === 'ko' ? '/logo_korean.png' : '/logo_english.png',
  alt: "logo",
}))`
  height: 2rem;
  margin-right: 0.8rem;
  margin-bottom: 0.2rem;
`;

export const WebsiteRights = styled.small`
  color: #666666;
  margin-bottom: 16px;
  font-size: 14px;
`;

export const CompanyInfoContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 10px 20px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CompanyInfoGrid = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  
  @media screen and (max-width: 768px) {
    gap: 10px;
  }
`;

export const CompanyInfoItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--text-muted);
  font-size: 13px;
  line-height: 1.6;
  text-align: center;
  
  @media screen and (max-width: 768px) {
    font-size: 12px;
    flex-direction: column;
    align-items: center;
  }
`;

export const CompanyInfoLabel = styled.span`
  font-weight: 600;
  color: var(--text-secondary);
  margin-right: 8px;
  white-space: nowrap;
  min-width: fit-content;
`;

export const CompanyInfoValue = styled.span`
  color: var(--text-muted);
  word-break: keep-all;
  
  @media screen and (max-width: 768px) {
    word-break: break-word;
  }
`;

export const CompanyInfoDivider = styled.span`
  margin: 0 10px;
  color: #d0d0d0;
  
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const SocialIcons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 80px;
  margin: 0 50px;
`;

export const SocialIconLink = styled.a`
  color: #402204;
  font-size: 24px;
  transition: all 0.3s ease;

  &:hover {
    color: #fcd13f;
    transform: translateY(-3px);
  }
`;
